import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setDeviceSize } from "../../../reducers/loginLocalStorage";
import useWindowSize from "../../../common/hooks/useWindowSize";
import breakpoints from "../../../common/scss/breakpoints.module.scss";
import { isUrlIncludesRoutes } from "../../../common/util/routeUtils";
import { BusinessSelectorToast } from "../../BusinessSelector/BusinessSelectorToast/BusinessSelectorToast";
import { TopNavigationBar } from "../../Navigation/TopNavigationBar/TopNavigationBar";
import { SideNavigationPanel } from "../../Navigation/SideNavigationPanel/SideNavigationPanel";
import { MobileNavigationBar } from "../../Navigation/MobileNavigationBar/MobileNavigationBar";
import { useGetNavigationQuery } from "../../../services/MyBizShell/mybizShellAPI";

export interface SiteHeaderProps {
  displayPeriodSelector: boolean;
}

export const SiteHeader = ({ displayPeriodSelector }: SiteHeaderProps) => {
  const { deviceSize } = useAppSelector((state) => state.loginLocalStorage);
  const dispatch = useAppDispatch();
  const { width } = useWindowSize();

  const { aff, abo, isoCountryCode } = useAppSelector((state) => state.boot.user);
  const period = useAppSelector((state) => state.period.selectedPeriod);
  const {
    data: navigationData,
    isLoading: isNavigationLoading,
    isError: isNavigationError,
  } = useGetNavigationQuery({ aff, abo, period, isoCountryCode }, { skip: !aff || !abo || !period });

  useEffect(() => {
    if (width) {
      const breakpoint = Number(breakpoints.desktop);
      const newDeviceSize = Number(width) > breakpoint ? "desktop" : "mobile";

      if (deviceSize !== newDeviceSize) {
        dispatch(setDeviceSize({ deviceSize: newDeviceSize }));
      }
    }
  }, [deviceSize, dispatch, width]);

  if (isUrlIncludesRoutes()) {
    return <></>;
  }

  const transitionToMobileNavbar = Number(breakpoints.desktop);

  return (
    <>
      <ToastContainer className={"App__toastContainer"} position="top-center" autoClose={4000} />
      <BusinessSelectorToast />
      {width !== undefined &&
        (Number(width) >= transitionToMobileNavbar ? (
          <>
            <TopNavigationBar displayPeriodSelector={displayPeriodSelector} />
            <SideNavigationPanel
              navigationData={navigationData}
              isLoading={isNavigationLoading}
              isError={isNavigationError}
            />
          </>
        ) : (
          <MobileNavigationBar
            navigationData={navigationData}
            isLoading={isNavigationLoading}
            isError={isNavigationError}
          />
        ))}
    </>
  );
};
